/* eslint-disable react/jsx-max-props-per-line */
import { FilterMatchMode, Slider } from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

export const CriteriaSliderComponent = (props) => {
    const {
        colClass,
        disabled,
        id,
        label,
        labelOnRight,
        name,
        onChange,
        value,
       min, max, step,
       refreshFromBackend,
    } = props;
  
    return (
        <div className={colClass}>
            <div className='row'>
                <div className='col-md-12 form-group' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '66px' }}>
                    {label !== undefined ? (
                        <label id={`${id}-label-id`} className='p-label' htmlFor={`${id}-input`} style={{width: '100%'}}>
                            {label} {value[0]}% : {value[1]==100 ? 'Max' : value[1]}%
                        </label>
                    ) : null}
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}> 
                     <Slider 
                         aria-describedby={`${id}-error`}
                         aria-label={label}
                         aria-labelledby={label === undefined ? `${id}-label-id` : undefined}
                         key={id}
                         id={id}
                         name={name}                         
                         min={min}
                         max={max}
                         style={{width: '100%'}}
                         inputStyle={{width: '100%'}}
                         value={value}
                         onChange={(e) =>
                            onChange
                                ? onChange(
                                      'SLIDER',
                                      [name],
                                      e,
                                      FilterMatchMode.CONTAINS,
                                      refreshFromBackend,
                                      null
                                  )
                                : null
                        }
                      className="w-14rem" range />                                          
                    </div>           
                </div>
            </div>
        </div>
    );
};

CriteriaSliderComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    min: undefined,
    max: undefined, 
    step: 1,   
    refreshFromBackend: false,
};

CriteriaSliderComponent.propTypes = {
    colClass: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    refreshFromBackend: PropTypes.bool,
};

export default withTranslation()(CriteriaSliderComponent);
